/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_developer_business_api_keys_create_drawer_permissions_label = /** @type {(inputs: {}) => string} */ () => {
	return `Permisos Solicitados`
};

const en_developer_business_api_keys_create_drawer_permissions_label = /** @type {(inputs: {}) => string} */ () => {
	return `Requested Permissions`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const developer_business_api_keys_create_drawer_permissions_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.developer_business_api_keys_create_drawer_permissions_label(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("developer_business_api_keys_create_drawer_permissions_label", locale)
	if (locale === "es") return es_developer_business_api_keys_create_drawer_permissions_label(inputs)
	return en_developer_business_api_keys_create_drawer_permissions_label(inputs)
};
export { developer_business_api_keys_create_drawer_permissions_label as "developer.business_api_keys.create_drawer.permissions_label" }